// this file gets replaced with the real value during the build
const Version = '6.4.0';

export { Version as default };
